import { Check, Star } from "lucide-react";
import { imageUrl } from "@/lib/api";
import { typeContent } from "@/lib/experienceTypes";

export const coverCandidates = (f) => {
  const tc = typeContent(f.type);
  const out = f.images.map((p) => ({ path: p, label: "Own photo" }));
  f.stays.forEach((s, i) => (s.images || []).forEach((p) => { if (!out.some((o) => o.path === p)) out.push({ path: p, label: s.title?.trim() || `${tc.listing.item} ${i + 1}` }); }));
  return out;
};

export const CoverPicker = ({ f, onChange }) => {
  const options = coverCandidates(f);
  if (options.length < 2) return null;
  const current = options.some((o) => o.path === f.cover) ? f.cover : options[0].path;
  return (
    <div data-testid="cover-picker">
      <p className="field-label">Cover photo <span className="font-normal text-muted-foreground">(tap any photo to make it the cover)</span></p>
      <ul className="grid grid-cols-3 gap-2 sm:grid-cols-5">
        {options.map((o) => {
          const on = o.path === current;
          return (
            <li key={o.path}>
              <button type="button" onClick={() => onChange(o.path)} aria-pressed={on} aria-label={`Use ${o.label} photo as cover`} data-testid={`cover-option-${o.path.split("/").pop()}`}
                className={`group relative block aspect-[4/3] w-full overflow-hidden rounded-lg border-2 transition-[border-color,opacity] ${on ? "border-primary" : "border-transparent opacity-75 hover:opacity-100"}`}>
                <img src={imageUrl(o.path)} alt="" loading="lazy" className="img-cover" />
                <span className="absolute inset-x-0 bottom-0 truncate bg-black/60 px-1.5 py-0.5 text-left text-[10px] text-white">{o.label}</span>
                {on && <span className="absolute right-1.5 top-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-primary text-primary-foreground" data-testid="cover-selected"><Star className="h-3.5 w-3.5" /></span>}
                {!on && <span className="absolute right-1.5 top-1.5 hidden h-6 w-6 items-center justify-center rounded-full bg-background/80 group-hover:flex"><Check className="h-3.5 w-3.5" /></span>}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
